import i18next from 'i18next'
import { OptionType } from 'src/types/menu'
import { v4 as uuid } from 'uuid'

import { ROUTES } from '../constants'

export const getSidebarDefaultOptions = (isAdmin: boolean): OptionType[] => {
  return [
    ...(isAdmin
      ? [
          {
            id: uuid(),
            title: i18next.t('sidebar.links.mobileApps'),
            code: 'mobile_apps',
            viewCode: ROUTES.CONFIG_MOBILE_APPS,
            hasChild: false,
            childrenMenu: [],
          },
          {
            id: uuid(),
            title: i18next.t('sidebar.links.mobileScreens'),
            code: 'mobile_screens',
            viewCode: ROUTES.CONFIG_MOBILE_SCREENS,
            hasChild: false,
            childrenMenu: [],
          },
          // {
          //   id: uuid(),
          //   title: i18next.t('sidebar.links.mobileMaps'),
          //   code: 'mobile_maps',
          //   viewCode: ROUTES.CONFIG_MOBILE_MAPS,
          //   hasChild: false,
          //   childrenMenu: [],
          // },
          {
            id: uuid(),
            title: i18next.t('sidebar.links.mobileListItems'),
            code: 'mobile_list_items',
            viewCode: ROUTES.CONFIG_MOBILE_LIST_ITEMS,
            hasChild: false,
            childrenMenu: [],
          },
          {
            id: uuid(),
            title: i18next.t('sidebar.links.mobileForms'),
            code: 'mobile_forms',
            viewCode: ROUTES.CONFIG_MOBILE_FORMS,
            hasChild: false,
            childrenMenu: [],
          },
          // {
          //   id: uuid(),
          //   title: i18next.t('sidebar.links.mobileSearchAssistants'),
          //   code: 'mobile_search_assistants',
          //   viewCode: ROUTES.CONFIG_MOBILE_SEARCH_ASSISTANTS,
          //   hasChild: false,
          //   childrenMenu: [],
          // },
          {
            id: uuid(),
            title: i18next.t('sidebar.links.mobileGlobalVariables'),
            code: 'mobile_global_variables',
            viewCode: ROUTES.CONFIG_MOBILE_GLOBAL_VARIABLES,
            hasChild: false,
            childrenMenu: [],
          },
          {
            id: uuid(),
            title: i18next.t('sidebar.links.mobileReports'),
            code: 'mobile_reports',
            viewCode: ROUTES.CONFIG_MOBILE_REPORTS,
            hasChild: false,
            childrenMenu: [],
          },
          {
            id: uuid(),
            title: i18next.t('sidebar.links.displayRules'),
            code: 'display_rules',
            viewCode: ROUTES.CONFIG_DISPLAY_RULES,
            hasChild: false,
            childrenMenu: [],
          },
          {
            id: uuid(),
            title: i18next.t('sidebar.links.styleSettings'),
            code: 'style_settings',
            viewCode: ROUTES.CONFIG_STYLE_SETTINGS,
            hasChild: false,
            childrenMenu: [],
          },
        ]
      : []),
  ]
}
